<template>
	<div id="app" class="screenSize">
		<router-view v-bind:api="api"></router-view>
	</div>
</template>

<script>
import apiConf from 'apiConf';
import remoteAPI from '@/libs/api.js';
import lib from '@/libs/main.js';

window.addEventListener("orientationchange", function(){setTimeout(function(){ lib.orientation()}, 500)});

function workerScope() {
	try{
		var url = new URL(apiConf.url).pathname;
	}catch(e){}
	return (url.length && url) || '/remote';
}

export default {
	name: 'App',
	data() {
		return {
			api : new remoteAPI(apiConf.url)
		};
	},
	created : function(){
		let serviceWorkerReady = false, self = this;
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('static/worker.js', {scope :  workerScope()})
			.then(function(registration) {
				serviceWorkerReady = true;
			}, function(err) {
				console.log('ServiceWorker registration failed: ', err);
			});
			navigator.serviceWorker.addEventListener('message', function(event){
				if(event.data.type == "Bearer" && event.data.token) {
					self.api.setToken(event.data.token);
					localStorage.setItem("Bearer", event.data.token);
				} else if(event.data.type == "log") alert(JSON.stringify(event.data.message));
			});
		} else console.log('Service workers not supported');

		self.api.onTokenUpdate(function(newToken){
			localStorage.setItem("Bearer", newToken);
			if(serviceWorkerReady && navigator.serviceWorker.controller) { //notify serviceWorker token is updated
				navigator.serviceWorker.controller.postMessage({type:"Bearer", token : newToken});
			}
		});
	},
	mounted : lib.orientation
};
</script>



// WEBPACK FOOTER //
// src/App.vue